// Customers actions
import axios from 'axios';
import i18n from '@/i18n';
import types from '../../types';
/* eslint-disable */
export default {
  [types.GET_CUSTOMERS]: async (context, payload) => {
    try {
      await axios.get(`customer/get-list?page=${payload.page}${payload.query}`).then((res) => {
        if(payload.page == 1){
          context.commit('CLEAR_CUSTOMERS');
          context.commit('STORE_CUSTOMERS', res.data.data);
        } else {
          context.commit('STORE_CUSTOMERS', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_CUSTOMERS]: ({ commit }, payload) => {
    commit('STORE_CUSTOMERS', payload);
  },
  [types.CLEAR_CUSTOMERS]: (context) => {
    context.commit('CLEAR_CUSTOMERS');
  },
  [types.SEARCH_CUSTOMERS]: async ({commit, getters }, payload) => {
    let filter = {};
    if(Object.keys(getters.get_active_filter).length > 0) {
      filter = getters.get_active_filter;
    } else if (Object.keys(getters.get_active_tmp_filter).length > 0) {
      filter = getters.get_active_tmp_filter;
    }
    try {
      await axios.get(`customer?search=${JSON.stringify(filter)}&searchTerm=${getters.get_search_term}`).then((res) => {
        commit('CLEAR_CUSTOMERS');
        commit('STORE_CUSTOMERS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_CUSTOMER]: async (context, payload) => {
    try {
      await axios.get(`customer/${payload}/get`).then((res) => {
        context.commit('STORE_CUSTOMER', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.ADD_CUSTOMER]: async (context, payload) => {
    try {
      await axios.post('customer/create', payload).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('contact_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_CUSTOMER]: async (context, payload) => {
    try {
      await axios.put(`customer/${payload.id}/update`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('contact_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_CUSTOMERS]: async (context, payload) => {
    try {
      if(payload.type == 'byFilter'){
        // console.log('IZ FILTERA')
        return await axios.post('customer/delete-list', {
          search: payload.search,
          searchTerm: payload.searchTerm,
          total_count: payload.count,
        });
      } else {
        // console.log('IZ IDJEVA')
        return await axios.delete(`customer/0/delete?ids=[${payload.ids}]`);
      }
    } catch (err) {
      console.error(err);
    }
  },
  [types.ADD_CUSTOMER_ADDRESS]: async (context, payload) => {
    try {
      return await axios.post(`/customer/${payload.id}/address`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('customer_address_added_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.EDIT_CUSTOMER_ADDRESS]: async (context, payload) => {
    try {
      return await axios.put(`/customer/${payload.id}/address/${payload.addressId}`, payload.form).then(() => {
        context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('customer_address_edited_successfully'),
          type: 'success-window',
          iconName: 'check',
        });
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.CLEAR_CUSTOMER_FROM_STORE]: (context) => {
    context.commit('CLEAR_CUSTOMER_FROM_STORE');
  },
  [types.DELETE_CUSTOMER_ADDRESS]: async (context, payload) => {
    try {
      return await axios.delete(`/customer/${payload.customerId}/address/${payload.addressId}`).then(() => {
        // context.commit('SHOW_NOTIFICATION_BAR', {
        //   message: i18n.t('customer_address_added_successfully'),
        //   type: 'success-window',
        //   iconName: 'check',
        // });
      });
    } catch (err) {
      console.error(err);
    }
  },
};
